import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Rights Status List with Query (for remote operations)
export const getWaterRightsStatusListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_RIGHTS_STATUSES}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Rights Status List with Query
export const getWaterRightsStatusList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_RIGHTS_STATUSES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Rights Status
export const getWaterRightsStatus = water_rights_status_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_RIGHTS_STATUS}${water_rights_status_id}`
	);
};

// Add New Water Rights Status
export const addNewWaterRightsStatusApi = water_rights_status => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_RIGHTS_STATUS}`,
		water_rights_status
	);
};

// Update Water Rights Status
export const updateWaterRightsStatusApi = water_rights_status => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_RIGHTS_STATUS}${water_rights_status._id}`,
		water_rights_status
	);
};

// Delete Water Rights Status
export const deleteWaterRightsStatusApi = water_rights_status_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_RIGHTS_STATUS}${water_rights_status_id}`
	);
};

// Check if Water Rights Status Exists
export const checkWaterRightsStatusExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WATER_RIGHTS_STATUS_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
